module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nagios-mini"
  }, [_c('div', {
    staticClass: "nagios-container"
  }, [_c('div', {
    staticClass: "nagios-summary",
    class: _vm.summaryClass
  }, [_c('h2', [_vm._v("Infrastructure Availability")]), _vm._v(" "), _c('div', {
    staticClass: "nagios-up-pct",
    class: _vm.upClass
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.upPct) + "\n\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'OK'),
      expression: "mode == 'OK'"
    }],
    staticClass: "nagios-all-up"
  }, [_c('h2', [_vm._v("All " + _vm._s(_vm.itemCount) + " monitored items are up!")]), _vm._v(" "), _c('p', [_vm._v("Last event: " + _vm._s(_vm.lastEventItem))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.lastEventTime))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'Problem'),
      expression: "mode == 'Problem'"
    }],
    staticClass: "nagios-problems"
  }, _vm._l((_vm.problems), function(value, key) {
    return _c('div', {
      key: key,
      staticClass: "nagios-host"
    }, [_c('h2', [_vm._v(_vm._s(value.host.displayName) + ": "), _c('span', {
      class: _vm._f("asHostCssClass")(value.host.status)
    }, [_vm._v(_vm._s(_vm.describeHostState(value.host.status)))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (value.services.length > 0),
        expression: "value.services.length > 0"
      }],
      staticClass: "services"
    }, _vm._l((value.services), function(service) {
      return _c('div', {
        key: service.name,
        staticClass: "service",
        class: _vm._f("asServiceCssClass")(service.status)
      }, [_vm._v(_vm._s(service.description))])
    }))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-29f3e4ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/nagios-mini.vue
// module id = 567
// module chunks = 0